import RevenueBillingRoute from "@/vnext/routes/revenue/RevenueBillingRoute";

export default function WebhookLogsRoute() {
  return <RevenueBillingRoute mode="settings-webhook-logs" />;
}
